import { render, staticRenderFns } from "./ServePage.vue?vue&type=template&id=47c58b34&scoped=true&"
import script from "./ServePage.vue?vue&type=script&lang=js&"
export * from "./ServePage.vue?vue&type=script&lang=js&"
import style0 from "./ServePage.vue?vue&type=style&index=0&id=47c58b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c58b34",
  null
  
)

export default component.exports